import { useTranslation } from "react-i18next";
import CustomerTable from "./CustomerTable";
import getAllAdmin from "../../../hooks/getAllAdmin";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import { useEffect, useState } from "react";

const SuspendedCustomers = () => {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const getAllData = async () => {
      const res = await getAllAdmin("admin/getsuspendedcustomer");
      if (res.status_code === 200) {
        setCustomers(res.data);
      }
      setLoading(false);
    };
    getAllData();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <h2 className="text-title text-lg md:text-2xl pb-2">
        {t("Suspended Customers")}
      </h2>
      <CustomerTable customerData={customers} isSuspended={true} />
    </>
  );
};

export default SuspendedCustomers;
